var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    {
      attrs: { name: "modal", mode: "in-out", appear: "" },
      on: {
        beforeEnter: _vm.beforeEnter,
        afterEnter: _vm.afterEnter,
        beforeLeave: _vm.beforeLeave,
        afterLeave: _vm.afterLeave,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show",
            },
          ],
          staticClass: "modal is-active",
        },
        [
          _c("div", {
            staticClass: "modal-background",
            on: { click: _vm.deactivate },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "modal-card" }, [
            _c("header", { staticClass: "modal-card-head" }, [
              _c("p", { staticClass: "modal-card-title" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _vm._v(" "),
              _c("button", {
                staticClass: "delete",
                attrs: { type: "button" },
                on: { click: _vm.deactivate },
              }),
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "modal-card-body" },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _c(
              "footer",
              { staticClass: "modal-card-foot" },
              [
                _vm._t(
                  "footer",
                  function () {
                    return [
                      _c(
                        "a",
                        {
                          staticClass: "button is-primary",
                          on: { click: _vm.ok },
                        },
                        [_vm._v(_vm._s(_vm.$pgettext("Global", "OK")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        { staticClass: "button", on: { click: _vm.cancel } },
                        [_vm._v(_vm._s(_vm.$pgettext("Global", "Cancel")))]
                      ),
                    ]
                  },
                  { ok: _vm.ok, cancel: _vm.cancel }
                ),
              ],
              2
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }